import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadWorksWithNormativities
export default function RWWNContent() {
    const data = useAppSelector(state => state.mapTooltip.data)
    const { WorkState, EventYear, EventTypeString, LengthAlongRoad, ExecutorOrgName } = data ?? {}
    const formattedLength = typeof LengthAlongRoad === 'number'
        ? LengthAlongRoad.toFixed(2).replace('.', ',')
        : (LengthAlongRoad ?? null)

    return (
        <>
            <div className="tooltip-info-row">Состояние: {WorkState ?? '—'}</div>
            <div className="tooltip-info-row">Год: {EventYear}</div>
            <div className="tooltip-info-row">Вид: {EventTypeString}</div>
            <div className="tooltip-info-row">Протяжённость: {formattedLength} км</div>
            <div className="tooltip-info-row">Исполнитель: {ExecutorOrgName ?? 'Не известен'}</div>
        </>
    )
}
